import React, { useEffect, useState } from 'react'
import { userBridge, getUA, callNativeByParams } from '@penguin/utils'
import { STATS_MAP } from '@/utils'
import { getEncodeUserId, getSlotAd } from '@/api'
import { replaceUrlParam } from '@/utils'
import classnames from 'classnames'
import qs from 'query-string'
import { useTop } from '@/hooks'
import styles from './index.module.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
const ua = getUA()

const SLOT_KEYS = {
  right: 'marketing-h5-haoka-right-banner',
  left: 'marketing-h5-haoka-left-banner',
  top: 'marketing-h5-haoka-top-banner',
}

const CardAd = () => {
  const navInfo = callNativeByParams('getAppStateBarAndNavBarHeight') as {
    stateBarHeight: string
    navBarHeight: string
    webViewHeight: string
  }
  const { wrapRef, scrollNav } = useTop()
  const { channel = '' } = qs.parse(location.search) as {
    channel: string
    tab: string
  }
  const [slotInfo, setSlotInfo] = useState({
    top: [],
    left: [],
    right: [],
  })

  const getSlot = async () => {
    const [top, left, right] = await Promise.all([
      getSlotAd({ slotKey: SLOT_KEYS.top }),
      getSlotAd({ slotKey: SLOT_KEYS.left }),
      getSlotAd({ slotKey: SLOT_KEYS.right }),
    ])
    setSlotInfo((pre) => ({
      ...pre,
      top: top?.images || [],
      left: left?.images || [],
      right: right?.images || [],
    }))
  }
  useEffect(() => {
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        STATS_MAP.cardAd.exposure,
        'CLK',
        {
          page: '新号卡页面',
          channel,
        },
      ],
    })
    getSlot()
    userBridge('showOrHiddenStateBar', {
      isHidden: 1,
    })
    return () => {
      userBridge('showOrHiddenStateBar', {
        isHidden: 0,
      })
    }
  }, [])

  const jumpUrl = (url: string) => {
    if (ua === 'app') {
      userBridge('pushWindow', {
        url,
        closeCurrentWindow: false,
        closeAllWindow: false,
      })
    } else {
      window.location.href = url
    }
  }

  const goPage = async (i: any, type?: string) => {
    let url = i.linkUrl
    if (type === 'jump') {
      jumpUrl(url)
      return
    }
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: [
        STATS_MAP.cardAd.click,
        'CLK',
        {
          channel,
          page: '新号卡页面',
          naem: i.name,
        },
      ],
    })
    const res = await getEncodeUserId()
    url = replaceUrlParam(url, 'channelOrderId', encodeURIComponent(res || ''))
    jumpUrl(url)
    return
  }

  return (
    <div
      className={classnames(
        ' relative p-3 rem:pt-[44px] w-full pb-10',
        styles['card'],
        styles['card-vip'],
      )}
      ref={(ref) => {
        wrapRef.current = ref
      }}
    >
      {ua === 'app' && (
        <div
          className={classnames(
            'w-full fixed z-10 top-0 left-0',
            scrollNav ? styles['navstyl'] : styles['unnavstyl'],
          )}
          style={{ paddingTop: +navInfo.stateBarHeight || 44 }}
        >
          <div className=' rem:h-[44px] relative flex items-center justify-center'>
            <img
              className='absolute w-6 h-6  left-1'
              src='//static.qiekj.com/static/web/image/icon-left_1686626401509.png'
              alt=''
              onClick={() => userBridge('popWindow')}
            />
            {scrollNav && <span className='rem:text-[17px] text-default'>胖乖营业厅</span>}
          </div>
        </div>
      )}
      <img
        className='absolute top-0 left-0 '
        src='//static.qiekj.com/static/web/image/card-one-page_1717125989665.png'
        alt=''
      />
      <Swiper
        autoplay={{
          delay: 1000,
        }}
        loop
        modules={[Autoplay]}
        className={classnames(styles['swiper'], 'rem:mt-[126px]')}
        direction={'vertical'}
      >
        {slotInfo.top?.map((i: any) => (
          <SwiperSlide key={i.linkUrl} className={classnames(styles['swiper-slide'])}>
            <img
              onClick={() => goPage(i, 'jump')}
              className='!w-full !h-full'
              src={i.imageUrl}
              alt=''
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className='relative rem:mt-[32px] flex flex-col items-center'>
        {!!slotInfo.right.length && (
          <img
            className='rem:w-[200px]'
            src='//static.qiekj.com/static/web/image/pg-package-title_1717125415059.png'
            alt=''
          />
        )}
        {slotInfo.right?.map((i: any) => {
          return (
            <img
              onClick={() => goPage(i)}
              className='rem:mt-[10px]'
              key={i.linkUrl}
              src={i.imageUrl}
            />
          )
        })}
        <img
          className={classnames('rem:w-[200px]', slotInfo.right.length && 'rem:mt-[22px]')}
          src='//static.qiekj.com/static/web/image/pg-card-title_1717125415059.png'
          alt=''
        />
        <img
          className='rem:mt-[6px]'
          src='//static.qiekj.com/static/web/image/left-top_1715842597832.png'
          alt=''
        />
        {slotInfo.left?.map((i: any) => {
          return (
            <img
              onClick={() => goPage(i)}
              className='rem:mt-[10px]'
              key={i.linkUrl}
              src={i.imageUrl}
            />
          )
        })}
        <img
          className=' rem:mt-[10px]'
          src='//static.qiekj.com/static/web/image/card-progress_1715842597832.png'
          alt=''
        />
        <img
          className=' rem:mt-[10px]'
          src='//static.qiekj.com/static/web/image/rule-one-page_1717125368244.png'
          alt=''
        />
      </div>
    </div>
  )
}

export default CardAd
